import { Button, Form, Modal, TextAreaForm } from 'uikit'
import { Field, Formik } from 'formik'
import { useBoolean } from 'react-use'
import { useQueryClient } from '@tanstack/react-query'
import * as Yup from 'yup'
import { formFields } from './CompletePaymentModal.constants'
import { useCompletePayment } from './services/useCompletePayment'

export const validationSchema = Yup.object().shape({
  [formFields.retryComment]: Yup.string()
    .matches(/\S/, 'Только пробелы не допустимы')
    .min(3, 'Минимум 3 символа')
    .required('Комментарий обязательное поле'),
})

export const CompletePaymentModal = ({ id }) => {
  const queryClient = useQueryClient()
  const [isOpen, setIsOpen] = useBoolean(false)
  const { mutate: competePayment, isPending: isLoading } = useCompletePayment(id)

  const handleSubmit = (values) => {
    competePayment(values, {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['paymentCard', id] })
        setIsOpen(false)
      }
    })
  }

  return (
    <>
      <Button width="100%" onClick={() => setIsOpen(true)} colorPalette="green">
        Провести
      </Button>
      <Modal isOpen={isOpen} onClose={() => setIsOpen(false)} size="sm" title="Проведение платежа">
        <Formik
          initialValues={{}}
          enableReinitialize
          onSubmit={handleSubmit}
          validationSchema={validationSchema}
        >
          {(formProps) => {
            return (
              <Form
                footer={
                  <Button
                    colorPalette="orange"
                    loading={isLoading}
                    onClick={() => formProps.handleSubmit()}
                  >
                    Подтвердить
                  </Button>
                }
              >
                <Field
                  component={TextAreaForm}
                  name={formFields.retryComment}
                  placeholder="Введите комментарий"
                />
              </Form>
            )
          }}
        </Formik>
      </Modal>
    </>
  )
}
